import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_SALARY_TYPES } from './get-salary-types.hook';
import { GET_SALARY_TYPES_BY_IDS } from './get-salary-types-by-ids.hook';
import { GET_SALARY_TYPE_BY_ID } from './get-salary-types-by-id.hook';
import { GET_ALL_SALARY_TYPES } from './get-all-salary-types.hook';



export const DELETE_SALARY_TYPES_BY_ID = gql`
  mutation deleteSalaryTypesById($id: String!) {
    deleteSalaryTypesById(id: $id) {
      _id
    }
  }
`;

export const useDeleteSalaryTypesById = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { t } = useTranslation('settings');
  const [deleteSalaryTypesById] = useMutation(DELETE_SALARY_TYPES_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteSalaryTypesById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('salaryTypes.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_SALARY_TYPES,
      GET_SALARY_TYPES_BY_IDS,
      GET_SALARY_TYPE_BY_ID,
      GET_ALL_SALARY_TYPES,
    ],
  });

  return deleteSalaryTypesById;
};
